import routes from "../../utils/constants/apiRoutes";
import { createSlice, Dispatch } from '@reduxjs/toolkit'
import axios from "../../utils/axios";
import { searchParams } from "src/@types/data";

export function createCardToken(cardData: any, orgCode?: string) {
    return async function createCardToken() {
        try {
            const response = orgCode ? await axios.post(`${orgCode}${routes.CARDS}`, cardData) : await axios.post(`${routes.CARDS}`, cardData);
            return response?.data;
        } catch (e) {
            console.log("error while createCardToken", e);
        }
    };
}

export function fetchCardByCustomerId(customerId: string, orgCode?: string) {
    return async function fetchCardByCustomerId() {
        try {
            const response = await axios.get(orgCode ? `${orgCode}${routes.CARDS}/check/${customerId}` : `${routes.CARDS}/check/${customerId}`);
            return response?.data;
        } catch (e) {
            console.log("error while fetchCardByCustomerId", e);
        }
    };
}

